<div class="email-settings">
  <p-toast position="top-right" key="securityToast"></p-toast> <!-- Added key for targeted messages -->

  <header class="email-settings__header">
    <h2>{{ 'settings.email.title' | translate }}</h2>
    <p>{{ 'settings.email.subtitle' | translate }}</p>
  </header>

  <p-card styleClass="security-settings__card">
    <form [formGroup]="emailForm" (ngSubmit)="onSubmit()" class="axede-form">
        <div class="simple-form">
            <div class="field-row">
                <label for="current-password">{{ 'settings.email.currentPassword.label' | translate }}</label>
                <div class="field-input-wrapper">
                    <p-password id="current-password" formControlName="currentPassword"
                        [feedback]="false" [toggleMask]="true"
                        [ngClass]="{'ng-invalid ng-dirty': isFieldInvalid('currentPassword')}"
                        aria-describedby="password-error"></p-password>
                    <small id="password-error" class="error-message"
                        *ngIf="isFieldInvalid('currentPassword')">
                        {{ getErrorMessage('currentPassword') }}
                    </small>
                </div>
            </div>
            <div class="field-row">
                <label for="email">{{ 'settings.email.email.label' | translate }}</label>
                <div class="field-input-wrapper">
                    <input type="text" id="email" formControlName="email"
                        pInputText [placeholder]="'settings.email.email.placeholder' | translate"
                        [ngClass]="{'ng-invalid ng-dirty': isFieldInvalid('email')}"
                        aria-describedby="email-error" />
                    <small id="email-error" class="error-message"
                        *ngIf="isFieldInvalid('email')">
                        {{ getErrorMessage('email') }}
                    </small>
                </div>
            </div>
        </div>

        <div class="form-actions">
            <button pButton type="button" [label]="'settings.email.actions.cancel' | translate"
                class="p-button-secondary" (click)="onCancel()"
                [disabled]="submitting"></button>
            <button pButton type="submit" [label]="'settings.email.actions.update' | translate"
                class="p-button-success"
                [loading]="submitting"></button>
        </div>
    </form>
  </p-card>
</div>
